'use client';
import React, { useState } from 'react';
import { Search, MapPin, Calendar, Users } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function PackagesHero() {
  const router = useRouter();
  const [destination, setDestination] = useState('');
  const [dates, setDates] = useState('');
  const [groupSize, setGroupSize] = useState('2');

  return (
    <section className="relative bg-safari-green overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-safari-yellow rounded-full translate-x-48 -translate-y-24"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-32 translate-y-16"></div>
      </div>
      <div className="relative max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-16 lg:py-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-safari-yellow/20 border border-safari-yellow/30 text-safari-yellow text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            <span className="w-1.5 h-1.5 bg-safari-yellow rounded-full"></span>
            150+ Curated Safari Experiences
          </div>
          <h1 className="text-3xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Discover East Africa&apos;s<br />
            <span className="text-safari-yellow">Most Breathtaking</span> Safaris
          </h1>
          <p className="text-white/70 text-lg mb-10">From the Maasai Mara to Amboseli , book with confidence, pay flexibly, experience Africa.

          </p>

          {/* Search Bar */}
          <div className="bg-white rounded-2xl p-2 shadow-xl flex flex-col md:flex-row gap-2">
            <div className="flex-1 flex items-center gap-3 px-4 py-3 border border-gray-100 rounded-xl hover:border-safari-yellow transition-colors">
              <MapPin size={18} className="text-safari-green flex-shrink-0" />
              <div className="flex-1">
                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Destination</p>
                <input
                  type="text"
                  placeholder="Maasai Mara, Amboseli..."
                  value={destination}
                  onChange={(e) => setDestination(e?.target?.value)}
                  className="w-full text-sm font-medium text-gray-800 outline-none placeholder:text-gray-400" />

              </div>
            </div>
            <div className="flex-1 flex items-center gap-3 px-4 py-3 border border-gray-100 rounded-xl hover:border-safari-yellow transition-colors">
              <Calendar size={18} className="text-safari-green flex-shrink-0" />
              <div className="flex-1">
                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Travel Dates</p>
                <input
                  type="text"
                  placeholder="15 Apr — 18 Apr 2026"
                  value={dates}
                  onChange={(e) => setDates(e?.target?.value)}
                  className="w-full text-sm font-medium text-gray-800 outline-none placeholder:text-gray-400" />

              </div>
            </div>
            <div className="flex items-center gap-3 px-4 py-3 border border-gray-100 rounded-xl hover:border-safari-yellow transition-colors">
              <Users size={18} className="text-safari-green flex-shrink-0" />
              <div>
                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Group Size</p>
                <select
                  value={groupSize}
                  onChange={(e) => setGroupSize(e?.target?.value)}
                  className="text-sm font-medium text-gray-800 outline-none bg-transparent">

                  {['1', '2', '3', '4', '5', '6', '7', '8+']?.map((s) =>
                  <option key={`group-${s}`} value={s}>{s} {s === '1' ? 'Person' : 'People'}</option>
                  )}
                </select>
              </div>
            </div>
            <button
              onClick={() => router?.push('/safari-packages-listing')}
              className="flex items-center gap-2 bg-safari-yellow text-gray-900 font-bold px-6 py-3.5 rounded-xl hover:bg-yellow-400 transition-all duration-150 active:scale-95 whitespace-nowrap">

              <Search size={18} />
              Search Safaris
            </button>
          </div>

          {/* Quick Filters */}
          <div className="flex flex-wrap gap-2 mt-4">
            {['Big Five', 'Family Friendly', 'Luxury Lodge', 'Budget Safari', 'Photography Tour', 'Walking Safari']?.map((tag) =>
            <button
              key={`quick-${tag}`}
              className="px-3 py-1.5 bg-white/10 hover:bg-safari-yellow hover:text-gray-900 text-white/80 text-xs font-medium rounded-full border border-white/20 hover:border-safari-yellow transition-all duration-150">

                {tag}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>);

}